import styled from "@emotion/styled";

interface ErrorMessageProps {
    titleText: string;
    errors: { id: string; name: string }[];
}

const StyledP = styled("p")({
    margin: 0,
});

const StyledUl = styled("ul")({
    listStyleType: "none",
    margin: 0,
    padding: 0,
});

/**
 * toast error message component
 */
const ErrorMessage = (props: ErrorMessageProps) => {
    const { titleText, errors } = props;

    return (
        <>
            <StyledP>{titleText}</StyledP>
            <StyledUl>
                {errors.map((err) => (
                    <li>{`ID ${err.id}, ${err.name}`}</li>
                ))}
            </StyledUl>
        </>
    );
};

export default ErrorMessage;
